"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformGaObject2Webview = void 0;
const CMS_COMPONENT = 'cms_component';
const GESTION = 'gestion';
const FUNNEL = 'funnel';
const MOVISTAR_LAYER_ADS = 'movistar_layer_google_ads';
const LAST_FUNNEL_KEYS = [
    { normalizedKey: "step", oldKeyName: 'funnel_step_name' },
    { normalizedKey: "value", oldKeyName: 'price' },
];
const LAST_GESTION_KEYS = [
    { normalizedKey: "step", oldKeyName: 'gestion_paso' },
    { normalizedKey: "transaction_type", oldKeyName: 'gestion_detalle' },
];
const LAST_CMS_KEYS = [
    { normalizedKey: "component_copy", oldKeyName: 'component_content' },
    { normalizedKey: "component_type", oldKeyName: 'component_name' },
    { normalizedKey: "user_interaction", oldKeyName: 'event_type' },
    { normalizedKey: "product", oldKeyName: 'component_product' },
];
const transformGaObject2Webview = (gaObject, options = { eventType: 'cms_component' }) => {
    let tempObj = Object.assign({}, gaObject);
    let res = {};
    switch (options.eventType) {
        case GESTION:
            res = {
                name: GESTION,
                step: '',
                gestion_sistema: '',
                transaction_type: '',
                monetary_transaction: false
            };
            //adaptamos los antiguios y elminamos los nuevos
            LAST_GESTION_KEYS.forEach(keyTranslation => {
                const { normalizedKey, oldKeyName } = keyTranslation;
                if (tempObj[oldKeyName]) {
                    res[normalizedKey] = tempObj[oldKeyName];
                    delete tempObj[oldKeyName];
                }
            });
            // combinamos para respetar keys nuevas no tipadas
            res = Object.assign(Object.assign({}, res), tempObj);
            break;
        case MOVISTAR_LAYER_ADS:
        case FUNNEL:
            res = {
                name: FUNNEL,
                step: '',
                transaction_detail: 'automatico',
                funnel_purchase_mode: '',
                value: '',
                transaction_type: 'capa',
                product: '',
                funnel_zip_zone: '',
                payment_method: '',
                monetary_transaction: true
            };
            // adaptamos los antiguos y eliminamos claves anteriores
            LAST_FUNNEL_KEYS.forEach(keyTranslation => {
                const { normalizedKey, oldKeyName } = keyTranslation;
                if (tempObj[oldKeyName]) {
                    res[normalizedKey] = tempObj[oldKeyName];
                    delete tempObj[oldKeyName];
                }
            });
            // añadimos las claves no eliminadas por si hay alguna no tipada
            res = Object.assign(Object.assign({}, res), tempObj);
            break;
        default:
        case CMS_COMPONENT:
            res = {
                name: "user_interaction",
            };
            // adaptamos los antiguos y eliminamos claves anteriores
            LAST_CMS_KEYS.forEach(keyTranslation => {
                const { normalizedKey, oldKeyName } = keyTranslation;
                if (tempObj[oldKeyName]) {
                    res[normalizedKey] = tempObj[oldKeyName];
                    delete tempObj[oldKeyName];
                }
            });
            // añadimos las claves no eliminadas por si hay alguna no tipada
            res = Object.assign(Object.assign({}, res), tempObj);
            break;
    }
    return res;
};
exports.transformGaObject2Webview = transformGaObject2Webview;
exports.default = exports.transformGaObject2Webview;
//# sourceMappingURL=index.js.map